import React, { FC } from 'react';
import { CloseIconButton, CloseIconWithTextStyles } from './CloseIcon.styles';
import { Icon } from '@blueprint/ui';

export type CloseIconWithTextProps = {
    onClick: () => void;
    text: string;
    testId: string;
};

export const CloseIconWithText: FC<CloseIconWithTextProps> = ({
    onClick,
    text,
    testId
}) => {
    return (
        <CloseIconWithTextStyles
            iconId="close"
            iconIdHover="close"
            iconColor="primary-brand"
            hoverColor="primary-brand"
            buttonColor="primary-brand"
            fullWidth
            content={text}
            onClick={onClick}
            testId={testId}
            backgroundColor="graphic-background-accent-light"
        />
    );
};

export type CloseIconProps = {
    onClick: () => void;
    testId: string;
};

export const CloseIcon: FC<CloseIconProps> = ({ onClick, testId }) => {
    return (
        <CloseIconButton onClick={onClick} data-testid={testId}>
            <Icon
                aria-label="close"
                iconId="close"
                color="primary-brand"
                size="large"
            />
        </CloseIconButton>
    );
};
